<template lang="pug">
  #cover.d-flex
    .container
      .row.justify-content-center.text-center.neutral-color.px-3.mt-4
        img.mb-4(src="/assets/img/Guanajuato_Portada.svg" alt='silueta de Guanajuato')
        h1.bolder.cover-title Informe sobre la situación de  fosas clandestinas en el estado de Guanajuato
        h1.lighter.cover-subtitle (enero de 2009 a julio de 2020)

</template>

<script>
export default {
  name: "cover"
};
</script>

<style lang="scss">
#cover {
  min-height: 55vh;
  background-image: url("/assets/img/Portada_FosasGuanajuato.png");
  flex-direction: column;
  justify-content: space-evenly;
  .cover-title {
    font-size: 2.5rem;
  }
  .cover-subtitle {
    font-size: 2rem;
  }
  img {
    max-width: 100px;
  }
}
// Small devices
@media (max-width: 420px) {
  #cover {
    .cover-title {
      font-size: 1.2rem;
    }
    .cover-subtitle {
      font-size: 1rem;
    }
  }
}
</style>
